import i18n from 'i18next';

import { REMOTION_PREFETCHING } from '@/constants';
import { TributeVideoExportStatus } from '@/enums';

export const getMessageForProgressBar = (status: string, progress: number) => {
  if (status === TributeVideoExportStatus.Preparing) {
    return `${i18n.t('preparing', { ns: 'common' })}...`;
  } else if (status === TributeVideoExportStatus.Pending) {
    return `${i18n.t('waitingForServer', { ns: 'common' })}...`;
  } else if (status === TributeVideoExportStatus.InProgress && progress >= 0) {
    return i18n.t('rendering', { ns: 'common' });
  } else if (status === TributeVideoExportStatus.RenderingCompleted) {
    return `${i18n.t('finalizing', { ns: 'common' })}...`;
  } else if (status === REMOTION_PREFETCHING) {
    return `${i18n.t('prefetchingAssets', { ns: 'common' })}`;
  } else {
    return '';
  }
};
